import React, { useContext, useEffect, useState } from 'react'
import GroupedDocumentUploadTable from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedDocumentUploadTable'
import Sidebar from '@Components/Sidebars/Sidebar'
import ModalPortal from '@Components/Popups/ModalPortal'
import EditUploadedDocumentsForm from '@Components/OverclaimView/DocumentForms/EditUploadedDocumentsForm'
import DisputeOptionItem from '@Components/OverclaimView/DisputeOptionSection/DisputeOptionItem'
import { OverclaimUploadedDocument } from '@Entities/overclaim/overclaim-uploaded-document'
import { useLocation } from 'react-router'
import { StoresContext } from '@App/contexts'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { isActionableOverclaimHelper } from '@App/helpers/is-overclaim-helper'

interface OverclaimDocumentTabProps {
    onClickUploadDocumentsOption: () => void
}

const OverclaimDocumentTab = ({ onClickUploadDocumentsOption }: OverclaimDocumentTabProps) => {
    const { overclaimViewStore } = useContext(StoresContext)
    const [overclaimDocumentToEdit, setOverclaimDocumentToEdit] = useState<OverclaimUploadedDocument | null>(null)
    const state = useLocation()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)
        overclaimViewStore.loadOverclaimDocumentsForCurrentOverclaimViewItem().finally(() => setLoading(false))
    }, [state])

    const editDocumentFormIsOpened = overclaimDocumentToEdit !== null

    const openEditDocumentForm = (document: OverclaimUploadedDocument) => {
        setOverclaimDocumentToEdit(document)
    }

    const closeEditDocumentForm = () => {
        setOverclaimDocumentToEdit(null)
    }

    return (
        <div id="detail-tab">
            {loading ? (
                <PointPreloader />
            ) : (
                <>
                    <GroupedDocumentUploadTable
                        onValidation={() => {}}
                        onAddDescriptionToDocumentClicked={(document: OverclaimUploadedDocument) =>
                            openEditDocumentForm(document)
                        }
                    />

                    {isActionableOverclaimHelper(overclaimViewStore.overclaimViewItem) && (
                        <div className="overclaim-item-bottom-section">
                            <DisputeOptionItem
                                title="Upload Documents"
                                body="Upload documents on this work to support your claim on this work."
                                onClick={onClickUploadDocumentsOption}
                                buttonText="Upload Documents"
                            />
                        </div>
                    )}
                </>
            )}

            <ModalPortal isOpen={editDocumentFormIsOpened}>
                <Sidebar
                    onClose={() => {
                        closeEditDocumentForm()
                    }}
                >
                    {overclaimDocumentToEdit && (
                        <EditUploadedDocumentsForm
                            overlaimUploadedDocument={overclaimDocumentToEdit}
                            onSaveClicked={closeEditDocumentForm}
                        />
                    )}
                </Sidebar>
            </ModalPortal>
        </div>
    )
}
export default OverclaimDocumentTab
